import { ANIMATION_C } from './ANIMATION_C'

export const ANIMATION_T_S = 0.2 * ANIMATION_C
